module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio52-ffdd66f6f20bd520645e5437e368f383.m4a";